import { Badge } from '../ui/Badge';

/**
 * Match-type chip. All first-class match_types from the plan (§4/§6).
 * Variant reflects "flavour" so the eye can quickly group inflows, outflows,
 * transfers and specialised (CC/loan/drawings) types.
 */
const LABELS = {
  invoice_payment: 'Invoice payment',
  purchase_payment: 'Purchase payment',
  internal_transfer: 'Transfer',
  credit_card_settlement: 'Card settlement',
  loan_drawdown: 'Loan drawdown',
  loan_repayment: 'Loan repayment',
  proprietor_drawing_out: 'Drawing out',
  proprietor_contribution_in: 'Proprietor contribution',
  personal_reimbursement: 'Reimbursement',
  refund_customer: 'Customer refund',
  refund_supplier: 'Supplier refund',
  bank_charge: 'Bank charge',
  bank_interest: 'Bank interest',
  manual_adjustment: 'Adjustment',
  opening_balance: 'Opening balance',
  other: 'Other',
};

const VARIANTS = {
  invoice_payment: 'success',
  refund_customer: 'warning',
  bank_interest: 'success',
  purchase_payment: 'default',
  refund_supplier: 'warning',
  bank_charge: 'warning',
  internal_transfer: 'neutral',
  credit_card_settlement: 'neutral',
  loan_drawdown: 'warning',
  loan_repayment: 'warning',
  proprietor_drawing_out: 'warning',
  proprietor_contribution_in: 'success',
  personal_reimbursement: 'neutral',
  manual_adjustment: 'neutral',
  opening_balance: 'neutral',
  other: 'neutral',
};

export function MatchTypeChip({ matchType, className }) {
  const key = typeof matchType === 'string' ? matchType : 'other';
  return (
    <Badge variant={VARIANTS[key] || 'neutral'} className={className}>
      {LABELS[key] || key}
    </Badge>
  );
}

export default MatchTypeChip;
